<template>
    <!--paragracph about me -->
    <div class="text-right mt-10 padding-section">
      <p class="sub-title leading-[1]">
      היי! איזה כיף שהגעת<br>
      נעים להכיר, אני מאיה
      </p>
      <p class="mt-7 section-content tracking-wide leading-[1.4]">
        זאת אני, סיטי גירל בכל רמ״ח איברי. משוטטת ברחובות, לוגמת קפה או יין בכל פינה חדשה שנפתחת, צופה בעוברים ושבים וגומעת ספרים בכל רגע פנוי. במאי 2023 החלטתי לצעוד בנתיב חדש ויצאתי לחיי נוודות, להגשים חלום ישן לטייל בעולם, לטעום תרבויות שונות (תרתי משמע – אני חובבת אוכל מושבעת!), ולהתאהב שוב ושוב בערים המדהימות שהאנושות יצרה.<br/><br>
חיי הנוודות שלי אינם רק הרפתקה אישית – כבוגרת תואר שני בעיצוב אורבני מ׳בצלאל׳, הם מהווים מעבדה חיה לחקר המרחב העירוני. בכל עיר אני מתעמקת בתרבות המקומית, בוחנת את המרקם העירוני, ולומדת כיצד תושבים מתנהלים במרחב. מהמטבח המקומי ועד לתשתיות העירוניות, כל פרט מספר סיפור על העיר ותושביה. <br/><br>



את התובנות והחוויות האלה אני מביאה לכל פרויקט שאני לוקחת. אני מאמינה שכדי ליצור מקומות שטוב לחיות בהם, צריך קודם כל להקשיב, לחקור ולהבין לעומק. וזה בדיוק מה שאני עושה – משלבת את הידע המקצועי שלי עם הניסיון העשיר מהשטח כדי ליצור פתרונות שעובדים באמת. <br/><br>



רוצה לראות עם מי ועל מה עבדתי עד עכשיו?
      </p>
    </div>
  
</template>

<script setup>
</script>

<style>

</style>